(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('InvoiceLineController', InvoiceLineController);

    InvoiceLineController.$inject = ['InvoiceLine'];

    function InvoiceLineController(InvoiceLine) {

        var vm = this;

        vm.invoiceLines = [];
        var loaded = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            InvoiceLine.query(function(result) {
                loaded = result;
                vm.invoiceLines = result;
                vm.searchQuery = null;
                vm.currentSearch = null;
            });
        }

        function search() {
        if (!vm.searchQuery) {
            vm.invoiceLines = loaded;
            vm.currentSearch = null;
            return;
        }
        /* There is no search endpoint for this entity. The XSearch service this used to call was
           JHipster Elasticsearch scaffolding that this application never had - injecting it threw
           "Unknown provider", which killed the whole controller, so the page rendered NOTHING at
           all. The list is loaded in full above, so the box filters what is already here. */
        var needle = String(vm.searchQuery).toLowerCase();
        vm.invoiceLines = loaded.filter(function(item) {
            return Object.keys(item).some(function(key) {
                var value = item[key];
                return value !== null && value !== undefined && typeof value !== 'object' &&
                    String(value).toLowerCase().indexOf(needle) !== -1;
            });
        });
        vm.currentSearch = vm.searchQuery;
        }

        function clear() {
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.invoiceLines = loaded;
        }
    }
})();
